import { getOrigin } from '../lib/url'

const environment = process.env.NODE_ENV

const isOnLocalhost = () => {
    return environment === 'development'
}

export const toV1 = (path, params) => {
    window.location.href = getV1PathWithOrigin(path, params)
}

export const getV1PathWithOrigin = (path, params) => {
    const origin = getOrigin()
    const v1Path = getV1Path(path, params)
    return isOnLocalhost() ? `${origin}/#/${v1Path}` : `${origin}/${v1Path}`
}

export const getV1Path = (path, params) => {
    switch (path) {
        // Home
        case '/home-okr':
            return 'app/home'
        //People
        case '/people/performance':
            return 'app/performance/users'
        // PROFILE
        case '/user/profile':
            return `app/users/${params.userId}`
        // OKR
        case '/okr/objectives':
            return `app/objectives/${params.objectiveId}`
        case '/okr/objectives/key-results':
            return `app/objectives/${params.objectiveId}/keyResults/${params.keyResultId}`
        case '/okr/objectives/tree':
            return `app/objectives/${params.objectiveId}/tree`
        // TALK
        case '/talk/feedbacks':
            return 'app/talk/feedbacks'
        // VALUES
        case '/values/networks':
            return 'app/values/networks'
        case '/values/subjects':
            return 'app/values/subjects'
        case '/values/scales':
            return 'app/values/scales'
        case '/values/questionnaires':
            return 'app/values/questionnaires'
        case '/values/categories':
            return 'app/values/categories'
        // REPORTS
        case '/reports/report':
            return 'app/report'
        case '/reports/objectives':
            return 'app/performance/sections'
        // ADMINISTRATOR
        case '/administrator/hierarchy':
            return 'app/admin/hierarchy'
        case '/administrator/occupation-groups':
            return 'app/admin/jobGroup'
        case '/administrator/users':
            return 'app/admin/users'
        case '/administrator/periods':
            return 'app/admin/periods'
        case '/administrator/tags':
            return 'app/tags'
        case '/administrator/integrations':
            return 'app/admin/integrations'
        case '/administrator/customers':
            return 'app/admin/customers'
        case '/login':
            return 'login'
        default:
            return '404'
    }
}
